import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { OrderHeader } from "./OrderHeader";
import { Groups } from "../../components/groups/Groups";
import { OrderForm } from "./OrderForm";
import { ordersOptions } from "./ordersOptions";
import { scheduledInvoicesOptions } from "./moloni/scheduled-invoices/scheduledInvoicesOptions";
import { OrdersDetail } from "./OrdersDetail";
import { actions } from "./ordersActions";
import { OrdersListHeader } from "./OrdersListHeader";
import {  fieldsQuery as ordersPaymentsFieldsQuery, ordersPaymentsOptions } from "./ordersPaymentsOptions";


export const fieldsQuery =
    "*.*,order_items.*,order_items.service_variant.sku,order_items.service_variant.service.*,order_items.service_variant.agreement.*,client_id.user_id.*,treatment.client.*,treatment.client.user_id.*,bank_transaction.category.*,orders_payments.*";

export const orderRoutes = [
    {
        path: "/orders",
        element: (
            <Records
                entity="orders"
                fieldsQuery={fieldsQuery}
                options={ordersOptions}
                heightOfHeaders={190}
                header={<OrdersListHeader />}
            />
        ),
    },
    {
        path: "/orders/:id",
        element: (
            <Record
                entity="orders"
                type="detail"
                fieldsQuery={fieldsQuery}
                options={ordersOptions.groupsOptions}
                header={<OrderHeader actions={actions} />}
                body={<OrdersDetail />}
            />
        ),
        children: [
            {
                path: "/orders/:id/detail",
                element: <Groups />,
            },
        ],
    },
    {
        path: "/orders/:id/update",
        element: <Record entity="orders" fieldsQuery={fieldsQuery} type="update" body={<OrderForm />} />,
    },
    {
        path: "/orders/create",
        element: <Record entity="orders" type="create" body={<OrderForm />} />,
    },
    {
        path: "/scheduled_invoices",
        element: (
            <Records
                entity="scheduled_invoices"
                fieldsQuery="*.*,order.treatment.client.*.*"
                heightOfHeaders={190}
                options={scheduledInvoicesOptions}
            />
        ),
    },
        {
        path: "/orders_payments",
        element: (
            <Records
                entity="orders_payments"
                fieldsQuery={ordersPaymentsFieldsQuery}
                heightOfHeaders={190}
                options={ordersPaymentsOptions}
          
            />
        ),
    },
];
